module.exports = __webpack_public_path__ + "img/ep_opportunity.1f2cf941.svg";